import { RoleName } from "../../constants";
import { usePickUserPermissions, useUserRoleSelector } from "../../store";
import { UserPermissionType } from "../../store/types/user-management";

export const useIsViewerPermission = (permission: string): boolean => {
  const role = useUserRoleSelector();
  const access = usePickUserPermissions(permission);

  if (!role) return false;

  return role.name === RoleName.Analyst && access === UserPermissionType.VIEWER;
};
